<block-ui>
  <div class="container-fluid">
    <div class="row" style="height: 70%;">
      <div class="col-12">
        <div class="row justify-content-end">
          <button [ngClass]="{'mNotAllowed': parametersForm.invalid}" class="btn btn-sm btn-light mx-1"
            [disabled]="parametersForm.invalid" (click)="onClickPrintReport()">
            <i class="fa fa-download" aria-hidden="true"></i> Descargar
          </button>
          <button [ngClass]="{'mNotAllowed': parametersForm.invalid}" class="btn btn-sm btn-light mx-1"
            [disabled]="parametersForm.invalid" (click)="onClickSendMailModal(modalSendMail)">
            <i class="fa fa-envelope" aria-hidden="true"></i> Enviar
          </button>
        </div>
        <form class="row" [formGroup]="parametersForm">
          <div class="col-3 p-1 my-1" *ngFor="let paramList of paramaterListGroup; index as i">
            <div class="container-fluid col-header">
              <div class="row my-1" *ngFor="let param of paramList; index as j" [ngSwitch]="param.Type">
                <div class="col-12 border rounded shadow-sm">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label [for]="'input' + i + '-' + j">{{ param.Name
                          }}<span class="text-danger" *ngIf="param.Required">
                            *</span></label>
                        <!-- FIRST INPUT TYPES -->
                        <div *ngIf="param.MappedPrealoadSource && param.MappedPrealoadSource.length > 0">
                          <input type="search" class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                            formControlName="{{ param.Name }}" *ngSwitchCase="1"
                            [ngbTypeahead]="searchType(GetIndex(param.GridCol, param.GridRow),instance,param.MappedPrealoadSource, $text)"
                            (focus)="focus$[GetIndex(param.GridCol, param.GridRow)].next($any($event).target.value)"
                            (click)="click$[GetIndex(param.GridCol, param.GridRow)].next($any($event).target.value)" #instance="ngbTypeahead" />
                        </div>


                        <div *ngIf="!param.MappedPrealoadSource">
                          <input type="search" class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                            formControlName="{{ param.Name }}" *ngSwitchCase="1" />
                        </div>

                        <!-- END FIRST INPUT TYPES -->



                        <input type="number" class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                          formControlName="{{ param.Name }}" *ngSwitchCase="2" />
                        <input type="date" class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                          formControlName="{{ param.Name }}" *ngSwitchCase="3" />
                        <input type="checkbox" class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                          formControlName="{{ param.Name }}" *ngSwitchCase="4" />


                        <!-- DROPDOW-SECTIONS LOADED BY A VIEW -->


                        <div *ngIf="param.PreloadedSource && param.PreloadedSource.length > 0">
                          <select class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                            formControlName="{{ param.Name }}" *ngSwitchCase="5">
                            <option [value]="option.Code" *ngFor="let option of param.PreloadedSource">
                              {{ option.Description }}
                            </option>
                          </select>
                        </div>


                        <!-- MANUAL FILLING -->
                        <div *ngIf="!param.PreloadedSource">
                          <select class="form-control form-control-sm" [attr.id]="'input' + i + '-' + j"
                            formControlName="{{ param.Name }}" *ngSwitchCase="5">
                            <option [value]="option.Value" *ngFor="let option of param.Options">
                              {{ option.Key }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <ng-template #modalSendMail let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Enviar por correo</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismissModal(false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <form class="row my-2" [formGroup]="emailForm">
              <div class="col-12">
                <div class="form-group mb-0">
                  <label>Destinatarios</label>
                  <input type="text" class="form-control form-control-sm" formControlName="Recipient" (keyup.enter)="
                      addRecipient(emailForm.get('Recipient').value)
                    " placeholder="Digite el correo y presione enter para agregarlo" />
                </div>
              </div>
              <div class="col-12 mb-2">
                <button type="button" *ngFor="let recipient of emailRecipients; index as i" class="btn border mr-1 mt-1"
                  style="box-shadow: none" (click)="onClickRemoveRecipient(i)">
                  {{ recipient }}
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Asunto</label>
                  <textarea class="form-control form-control-sm" formControlName="Subject" [ngClass]="{
                      'is-invalid':
                        emailFormControls.Subject.errors &&
                        emailFormControls.Subject.touched
                    }"></textarea>
                  <div *ngIf="emailFormControls.Subject.errors" class="invalid-feedback">
                    <div *ngIf="emailFormControls.Subject.errors.required">
                      Este campo es requerido
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label>Mensaje</label>
                  <textarea class="form-control form-control-sm" formControlName="Body" [ngClass]="{
                      'is-invalid':
                        emailFormControls.Body.errors &&
                        emailFormControls.Body.touched
                    }"></textarea>
                  <div *ngIf="emailFormControls.Body.errors" class="invalid-feedback">
                    <div *ngIf="emailFormControls.Body.errors.required">
                      Este campo es requerido
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="row justify-content-end">
              <button [ngClass]="{'mNotAllowed': emailForm.invalid}" class="btn btn-sm btn-light" [disabled]="
                  emailForm.invalid ||
                  !emailRecipients ||
                  emailRecipients.length === 0
                " (click)="onClickSendEmail()">
                <i class="fa fa-check" aria-hidden="true"></i> Continuar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</block-ui>